<!--  -->
<template>
<div class='sceneiframe'>
    <iframe :src="`${link}`" ></iframe>
    <bar :active='-1'></bar>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import bar from '../layout/sidebar.vue'
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    bar:bar
},
data() {
//这里存放数据
return {
    link:''
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {
    '$route':function(newval){       
        this.link = "ebook/index.html?pages="+newval.query.id;
    }
},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {
    
},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    this.link = "http://4dscene.4dage.com/wuhu/RuiJinMuseum/ebook/index.html?pages="+this.$route.query.id;
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
    .sceneiframe {
        width:100%;
        height:100%;
        iframe {
            width:100%;
            height:100%;
        }
        .top-icons {
            position: absolute;
            top: 1.5625vw;
            left: 1.5625vw;
            display: flex;
            justify-content: center;
            .icon {
                width: 2.08vw;
                &.back {
                margin-right: 1vw;
                }
            }
        }
    }
@media screen and (max-width:600px) {
    .sceneiframe {
        .top-icons {
            top: 6.67vw;
            left: 4vw;
            .icon {
                width:10.6vw;
                &.back {
                    margin-right:2vw;
                }
            }
        }
    }
}
</style>